import { render, staticRenderFns } from "./ForgotPasswordLanding.vue?vue&type=template&id=2c8f4c58&"
import script from "./ForgotPasswordLanding.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordLanding.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VForm,VSelect,VTextField})
